import EndFrame from './endFrame.container';

export default EndFrame;
